import { createFileRoute } from "@tanstack/react-router";

import { ShopifyFormPage } from "~/pages/connection-new/shopify-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/shopify",
)({
  component: ShopifyFormPage,
});
